import { useNavigate } from "react-router-dom";
import styles from "./refeicao.module.css";
import BottomNav from "../../components/BottomNav";

// Tela de escolha entre Almoço e Café da Manhã (pedido do usuário,
// 2026-10-14) - antes "Refeição" ia direto pro fluxo de almoço; agora que
// café da manhã também é agendável (mesma tabela fpd061, campo tipref), as
// duas viraram páginas próprias (/refeicao/almoco e /refeicao/cafe-manha)
// pra não misturar regras/telas diferentes (prazos, cardápio, tipo de prato
// só existem no almoço) - essa tela aqui só decide pra qual ir.
export default function Refeicao() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerIcon}>🍽️</div>
                <div className={styles.headerTexto}>
                    <h2>Refeição</h2>
                    <p>Escolha o que deseja agendar</p>
                </div>
            </div>

            <div className={styles.escolhaGrid}>
                <button className={styles.escolhaCard} onClick={() => navigate("/refeicao/almoco")}>
                    <span className={styles.escolhaIcone}>🍽️</span>
                    <span className={styles.escolhaInfo}>
                        <span className={styles.escolhaTitulo}>Almoço</span>
                        <span className={styles.escolhaDescricao}>Agendamento, tipo de prato e cardápio do dia</span>
                    </span>
                    <span className={styles.escolhaSeta}>›</span>
                </button>

                <button className={styles.escolhaCard} onClick={() => navigate("/refeicao/cafe-manha")}>
                    <span className={styles.escolhaIcone}>☕</span>
                    <span className={styles.escolhaInfo}>
                        <span className={styles.escolhaTitulo}>Café da Manhã</span>
                        <span className={styles.escolhaDescricao}>Agendamento para o café da manhã</span>
                    </span>
                    <span className={styles.escolhaSeta}>›</span>
                </button>
            </div>

            <BottomNav />
        </div>
    );
}
